import React from 'react';
import FoxFace from '@/widget/ui/images/avatars/fox-face.svg';
import styles from './Avatar.module.scss';

interface Props {
  sender: null | {
    avatarUrl: string | null;
  };
}

function Avatar({ sender }: Props) {
  return (
    <div className={styles.container}>
      {!!sender && !!sender.avatarUrl && <img className={styles.img} src={sender.avatarUrl} alt="" />}
      {(!sender || !sender.avatarUrl) && <img className={styles.emoji} src={FoxFace} alt="" />}
    </div>
  );
}

export default Avatar;
